import { render, staticRenderFns } from "./PsychologyReservation.vue?vue&type=template&id=82c9d298&scoped=true"
import script from "./PsychologyReservation.vue?vue&type=script&lang=js"
export * from "./PsychologyReservation.vue?vue&type=script&lang=js"
import style0 from "./PsychologyReservation.vue?vue&type=style&index=0&id=82c9d298&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c9d298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c9d298')) {
      api.createRecord('82c9d298', component.options)
    } else {
      api.reload('82c9d298', component.options)
    }
    module.hot.accept("./PsychologyReservation.vue?vue&type=template&id=82c9d298&scoped=true", function () {
      api.rerender('82c9d298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/PsychologyReservation.vue"
export default component.exports